import React from "react";
import { View } from "@/components/ui";
import { cn } from "@/lib/utils";

import { Typography } from "../typography";

export const Divider = ({
  vertical,
  children,
  className,
  dashed,
}: {
  vertical?: boolean;
  children?: React.ReactNode;
  className?: string;
  dashed?: boolean;
}) => {
  if (children) {
    return (
      <View className={cn("flex items-center", vertical ? "flex-col" : "flex-row", className)}>
        <View className={cn("bg-border-medium flex-1", vertical ? "pr-px" : "pt-px")}></View>
        <Typography className={cn("text-secondary-text px-2 text-sm", vertical && "rotate-90")}>
          {children}
        </Typography>
        <View className={cn("bg-border-medium flex-1", vertical ? "pr-px" : "pt-px")}></View>
      </View>
    );
  }
  return (
    <View
      className={cn(
        "border-border-medium",
        vertical ? "w-px border-r" : "h-px border-b",
        { "web:border-dashed native:border-dashed": dashed },
        className,
      )}
    />
  );
};
